import React, { FC, Suspense, useCallback, useEffect } from 'react';
import { SportShowcaseSelection } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { ErrorBoundary } from '@funtech-int/rival-react';
import { useAnalytics } from '@funtech-int/yango-shared';

import * as Showcase from '@/shared/components/Showcase';
import { useSportShowcaseQuery } from '@/shared/hooks/useSportShowcaseQuery';
import { PageSpinner } from '@/shared/components/PageSpinner';

import { PromoSelection } from '../PromoSelection/PromoSelection';
import { createSportShowcaseAnalytics } from '../../lib/analytics';

import styles from './Showcase.module.css';

interface SportShowcaseProps {
    id: string;
}

const ShowcaseContainer: FC<SportShowcaseProps> = (props) => {
    const { id } = props;
    const { sportShowcase, pagination } = useSportShowcaseQuery({ id });
    const analytics = useAnalytics(createSportShowcaseAnalytics);

    useEffect(() => {
        analytics.setShowcaseId(sportShowcase.id);
        analytics.pageShowed();
    }, [sportShowcase.id, analytics]);

    const renderItem = useCallback(
        (params: { item: SportShowcaseSelection; index: number }) => {
            const { item, index } = params;

            if (item.type === 'sport-promo') {
                const promoAnalytics = analytics.createSportPromoAnalytics(item, index);

                return (
                    <div key={item.id} className={styles.sportPromoBlock}>
                        <PromoSelection selection={item} analytics={promoAnalytics} />
                    </div>
                );
            }

            return null;
        },
        [analytics]
    );

    return (
        <Showcase.Layout
            items={sportShowcase.selections}
            renderItem={renderItem}
            pagination={pagination}
        />
    );
};

export const SportShowcase: FC<SportShowcaseProps> = ({ id }) => (
    <ErrorBoundary fallback={() => null}>
        <Suspense fallback={<PageSpinner absoluteCenter noOffset />}>
            <ShowcaseContainer id={id} />
        </Suspense>
    </ErrorBoundary>
);
